/**
 * Convertit en profondeur les clés camelCase d'une valeur en snake_case.
 *
 * Le sous-arbre d'une clé listée dans `preservedKeys` (comparée après
 * conversion) est recopié tel quel : seule la clé elle-même est convertie.
 */
export function camelToSnakeCase<T>(
  value: unknown,
  preservedKeys: ReadonlySet<string> = new Set(),
): T {
  if (Array.isArray(value)) {
    return value.map((item) => camelToSnakeCase(item, preservedKeys)) as T;
  }

  if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
    return Object.entries(value as Record<string, unknown>).reduce(
      (acc, [key, val]) => {
        const snakeKey = key.replace(
          /([a-z0-9])([A-Z])/g,
          (_match, prev: string, letter: string) => `${prev}_${letter.toLowerCase()}`,
        );
        acc[snakeKey] = preservedKeys.has(snakeKey) ? val : camelToSnakeCase(val, preservedKeys);
        return acc;
      },
      {} as Record<string, unknown>,
    ) as T;
  }

  return value as T;
}
